<template>
  <app-layout></app-layout>
</template>

<script>
  import AppLayout from './components/app-layouts/layout'

  export default {
    components: {
      'app-layout': AppLayout
    }
  }
</script>

<style>
  .ql-container,
  .ql-editor {
    font-family: 'Roboto', sans-serif !important;
    font-size: 16px !important;
  }

  .ql-table-menu {
    position: fixed;
    z-index: 9999;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    min-width: 200px;
    padding: 4px 0;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    color: #333;
  }

  .ql-table-menu-item {
    display: block;
    width: 100%;
    padding: 8px 16px;
    text-align: left;
    border: none;
    background: transparent;
    cursor: pointer;
    color: #333;
    white-space: nowrap;
  }

  .ql-table-menu-item:hover {
    background: #f5f5f5;
  }

  .ql-table-menu-item.disabled {
    color: #bbb;
    cursor: default;
  }

  .ql-table-menu-item.disabled:hover {
    background: transparent;
  }

  .ql-table-menu-separator {
    height: 1px;
    background: #e0e0e0;
    margin: 4px 0;
  }

  /* Tradução dos controles do Quill (tema snow): tooltip de link e menus suspensos.
     Quill 1.3.7 gera os rótulos via content: de pseudo-elementos no CSS do tema. */
  .ql-snow .ql-tooltip::before {
    content: 'Visitar URL:' !important;
  }

  .ql-snow .ql-tooltip[data-mode=link]::before {
    content: 'Inserir link:' !important;
  }

  .ql-snow .ql-tooltip[data-mode=formula]::before {
    content: 'Inserir fórmula:' !important;
  }

  .ql-snow .ql-tooltip[data-mode=video]::before {
    content: 'Inserir vídeo:' !important;
  }

  .ql-snow .ql-tooltip a.ql-action::after {
    content: 'Editar' !important;
  }

  .ql-snow .ql-tooltip a.ql-remove::before {
    content: 'Remover' !important;
  }

  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    content: 'Salvar' !important;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: 'Título 1' !important;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: 'Título 2' !important;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: 'Título 3' !important;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: 'Título 4' !important;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: 'Título 5' !important;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: 'Título 6' !important;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: 'Pequeno' !important;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: 'Grande' !important;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: 'Enorme' !important;
  }
</style>
